import React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import Layout from "./components/layouts";
import CardGroup from "./components/CardGroup";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Layout>
      <CardGroup />
    </Layout>
  </StrictMode>
);

